<template>
  <div
    class="flex flex-col lg:flex-row justify-between items-center max-w-7xl mx-auto px-3 py-8 md:py-14"
  >
    <p class="w-full sm:w-3/5 xl:w-1/3 mx-4 text-center text-sm font-semibold text-slate-600/90">
      Múltiples clientes confían en nosotros
    </p>

    <InfiniteSlideBar>
      <div class="flex grayscale sm:justify-between gap-10 sm:gap-24 opacity-80 ml-20">
        <Image
          v-for="brand in brands"
          :key="brand.name"
          class="h-10 !w-auto !lg:h-10 !lg:w-auto"
          :class="brand.class"
          :src="`/images/brands/${brand.name}.png`"
          :alt="`${brand.name}_logo`"
        />
      </div>
    </InfiniteSlideBar>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Image } from '@unpic/vue';
import InfiniteSlideBar from '@/components/InfiniteSlideBar.vue';

const brands = ref([
  { name: 'topi_topi', class: 'lg:h-15 bg-gray-600 rounded-full' },
  { name: 'softdevel', class: 'h-10' },
  { name: 'vpp', class: 'h-10' },
  { name: 'watching', class: 'h-10' },
  { name: 'xexo_moda', class: 'h-10' },
  { name: 'gessmac', class: 'h-10' }
]);
</script>
